module.exports = __webpack_public_path__ + "img/finish_line.ddff8ced.svg";